import one from "./Pents01.jpg";
import two from "./Pents02.jpg";
import three from "./Pents03.jpg";
import four from "./Pents04.jpg";
import five from "./Pents05.jpg";
import six from "./Pents06.jpg";
import seven from "./Pents07.jpg";
import eight from "./Pents08.jpg";
import nine from "./Pents09.jpg";
import ten from "./Pents10.jpg";
import page from "./Pents11.jpg";
import knight from "./Pents12.jpg";
import queen from "./Pents13.jpg";
import king from "./Pents14.jpg";

const pentacles = [
  one,
  two,
  three,
  four,
  five,
  six,
  seven,
  eight,
  nine,
  ten,
  page,
  knight,
  queen,
  king,
];

export default pentacles;
